import { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../lib/firebase";
import { setMetaName, setMetaProperty, setTitle, setFavicon } from "../utils/head";

import { CONFIG } from "../config";
/** ---- Config ---- */

const IMAGES_BASE = CONFIG.IMAGES_BASE

export default function GlobalMetaManager() {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    const off = onValue(ref(db, "metaconfig"), (snap) => {
      setMeta(snap.val() || {});
    });
    return () => off();
  }, []);

  useEffect(() => {
    if (!meta) return;
    const siteTitle = (meta.siteTitle || "").trim();
    const baseTitle = (meta.metaTitle || siteTitle || "Website").trim();
    const description = (meta.metaDescription || "").trim();
    const keywords = (meta.metaKeywords || "").trim();
    const favicon = meta.icon ? `${IMAGES_BASE}/${encodeURIComponent(meta.icon)}` : null;

    // Title
    setTitle(baseTitle);

    // Basic meta
    setMetaName("description", description);
    setMetaName("keywords", keywords);
    setMetaName("author", siteTitle || "Website");

    // OG defaults
    setMetaProperty("og:title", baseTitle);
    setMetaProperty("og:description", description);
    setMetaProperty("og:type", "website");
    setMetaProperty("og:site_name", siteTitle || "Website");

    // Favicon (global only)
    if (favicon) setFavicon(favicon);
  }, [meta]);

  return null; // no UI
}
